import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  exposure: 50,
  shadowIntensity: 0,
  shadowSoftness: 100,
  environmentImage: {
    src: "",
    type: "hdr",
  },
  useSkybox: false,
  autoRotate: false,
  disableZoom: false,
};

export const EnvironmentSlice = createSlice({
  name: "environment",
  initialState,
  reducers: {
    setExposure: (state, action) => void (state.exposure = action.payload),
    setShadowIntensity: (state, action) =>
      void (state.shadowIntensity = action.payload),
    setShadowSoftness: (state, action) =>
      void (state.shadowSoftness = action.payload),
    setEnvironmentImage: (state, action) =>
      void (state.environmentImage = {
        src: action.payload.src + "#.hdr",
        type: "hdr",
      }),
    setUseSkybox: (state) => void (state.useSkybox = !state.useSkybox),
    setAutoRotate: (state) => void (state.autoRotate = !state.autoRotate),
  },
});

export const {
  setExposure,
  setShadowIntensity,
  setShadowSoftness,
  setEnvironmentImage,
  setUseSkybox,
  setAutoRotate,
} = EnvironmentSlice.actions;
export default EnvironmentSlice.reducer;
